import { TranslationKey } from '@lib/translation';

export const LPR_MESSAGES_TRANSLATION_KEY: Record<string, TranslationKey> = {
  FLOCK_V3_LIMITATIONS: 'alpr.messages.flockV3Limitations',
  NO_RESULTS: 'alpr.messages.noResults',
  PROVIDER_UNSUPPORTED_FILTERS: 'alpr.messages.providerUnsupportedFilters',
  SEARCH_BOUNDARY: 'alpr.messages.searchBoundary',
};
